import { render, staticRenderFns } from "./app-header.component.vue?vue&type=template&id=1aaff5f2&scoped=true"
import script from "./app-header.component.vue?vue&type=script&lang=ts"
export * from "./app-header.component.vue?vue&type=script&lang=ts"
import style0 from "./app-header.component.vue?vue&type=style&index=0&id=1aaff5f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aaff5f2",
  null
  
)

export default component.exports